import { render, staticRenderFns } from "./ChangeClient.vue?vue&type=template&id=f76f0536&scoped=true&"
import script from "./index.ts?vue&type=script&lang=ts&"
export * from "./index.ts?vue&type=script&lang=ts&"
import style0 from "./style.css?vue&type=style&index=0&id=f76f0536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76f0536",
  null
  
)

export default component.exports